import PropTypes from 'prop-types'
import { useState } from 'react'
import { showMessage } from 'src/reducers/message'
// @mui
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
//
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ajaxCall } from 'src/reducers/axios'
import LinkItem from './link-item'
import Iconify from '../iconify'
import Tree from '../tree/tree'

// ----------------------------------------------------------------------

export default function CustomBreadcrumbs({
  links,
  actions,
  heading,
  moreLink,
  activeLast,
  sx,
  ...other
}) {

  const dispatch = useDispatch()

  const { appConfig } = useSelector((state) => state.app)

  const [openModal, setOpenModal] = useState(false)

  const [currentModalAction, setModalAction] = useState(null)

  const [selectedFile, setSelectedFile] = useState([])

  const [selectedFolderFrom, setSelectedFolderFrom] = useState([])

  const [selectedFolderTo, setSelectedFolderTo] = useState([])

  const currentPageURL = window.location.href

  const splitUrl = currentPageURL.split('/')

  const handleActionModal = (action) => {
    setModalAction({ ...action.modalContent })

    setOpenModal(true)
  }

  const submitChanges = (button) => {

    const resourceType = splitUrl[splitUrl.length - 1]

    const documentId = splitUrl[splitUrl.length - 3]

    const selectedFolder = selectedFolderTo[0]

    if(selectedFolder && selectedFile.length > 0){
      dispatch(
        ajaxCall({
          config: {
            url: button.endpoint,
            method: button.method,
            params: {},
            data: {
              documentId,
              resource: resourceType,
              target: selectedFolder,
              media: selectedFile,
            },
          },
          success: (res) => {
            dispatch(
              showMessage({
                message: res.data.message,
                type: 'success',
                autoHide: true,
              })
            )
            setOpenModal(false)

            setModalAction(null)

            setSelectedFile([])

            setSelectedFolderFrom([])

            setSelectedFolderTo([])
          },
          error: (err) => {
            showMessage({
              message: err.message || 'Si è verificato un errore, riprova',
              type: 'error',
              autoHide: true,
            })
          },
          activeLoading: button.withLoading,
        })
      )
    }
    else {
      if(!selectedFolder){
        dispatch(
          showMessage({
            message: "Seleziona almeno un file",
            type: 'error',
            autoHide: true,
          })
        )
      }
      if(selectedFile.length > 0){
        dispatch(
          showMessage({
            message: "Seleziona una cartella di destinazione",
            type: 'error',
            autoHide: true,
          })
        )
      }
    }
  }

  const selectionClick = (selectedFolderCloned, selectedFileCloned, isChecked, isSelectable, elem, multiSelect) => {

    if (!isSelectable) return

    const currentIndex =
      elem.type === 'folder' ? selectedFolderCloned.indexOf(elem.id) : selectedFileCloned.indexOf(elem.id)

    let newSelectedFolder

    let newSelectedFile

    if (elem.type === 'folder') {
      if (multiSelect.folders) {
        newSelectedFolder = [...selectedFolderCloned]
      } else {
        newSelectedFolder = []
      }

      if (isChecked) {
        newSelectedFolder.push(elem.id)

        if(elem.children && elem.children.length > 0 && multiSelect.folders){
          if (multiSelect.files) {
            newSelectedFile = [...selectedFileCloned]
          } else {

            newSelectedFile = []
          }

          elem.children.forEach((child) => {
            if(child.type === "file"){
              newSelectedFile.push(child.id)
            }
            else{
              [newSelectedFolder, newSelectedFile] = selectionClick(newSelectedFolder, newSelectedFile, true, child.selectable, child, multiSelect)
            }
          })
        }
      } else {
        newSelectedFolder.splice(currentIndex, 1)

        if(elem.children && elem.children.length > 0 && multiSelect.folders){
          if (multiSelect.files) {
            newSelectedFile = [...selectedFileCloned]
          } else {

            newSelectedFile = []
          }

          elem.children.forEach((child) => {
            const childIndex = child.type === 'folder' ? newSelectedFolder.indexOf(child.id) : newSelectedFile.indexOf(child.id)
            if(child.type ==="file"){
              newSelectedFile.splice(childIndex, 1)
            }
            else {
              [newSelectedFolder, newSelectedFile] = selectionClick(newSelectedFolder, newSelectedFile, false, child.selectable, child, multiSelect)
            }
          })
        }
      }
    } else {
      if (multiSelect.files) {
        newSelectedFile = [...selectedFileCloned]
      } else {

        newSelectedFile = []
      }

      if (isChecked) {
        newSelectedFile.push(elem.id)
      } else {
        newSelectedFile.splice(currentIndex, 1)
      }
    }

    return [newSelectedFolder, newSelectedFile]
  }

  return (
    <>
      <Box sx={{ ...sx }}>
        <Stack direction='row' alignItems='center'>
          <Box sx={{ flexGrow: 1 }}>
            {/* HEADING */}
            {heading && (
              <Typography variant='h4' gutterBottom>
                {heading}
              </Typography>
            )}

            {/* BREADCRUMBS */}
            {!!links.length && (
              <Breadcrumbs separator={<Separator />} {...other}>
                {links.map((link) => (
                  <LinkItem
                    key={link.name || ''}
                    link={link}
                    activeLast={activeLast}
                    disabled={link.name === links[links.length - 1].name}
                  />
                ))}
              </Breadcrumbs>
            )}
          </Box>

          {actions && (
          <Stack sx={{ flexShrink: 0 }} direction='row' alignItems='center' spacing={1}>
            {actions.map((action, index) => {
              const props = {}

              props.disabled = action.disabled

              if (action.type === 'modal') {
                props.onClick = () => handleActionModal(action)
              } else {
                props.to = appConfig.appPrefix + action.path
              }

              return (
                <Button
                  key={index}
                  variant='contained'
                  color='primary'
                  component={NavLink}
                  {...props}
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  <Iconify
                    icon={action.style?.icon}
                    sx={{
                      mr: 1,
                    }}
                  />
                  <span>{action.label}</span>
                </Button>
              )
            })}
          </Stack>
        )}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link
              key={href}
              href={href}
              variant='body2'
              target='_blank'
              rel='noopener'
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>

    {currentModalAction && (
      <Dialog fullWidth open={openModal} maxWidth='lg' size='md' onClose={() => setOpenModal(false)} sx={{ minHeight: '600px' }}>
        <DialogTitle>
          <Box display='flex' alignItems='center'>
            <Box flexGrow={1}>
              <Typography variant='h5'>{currentModalAction.title}</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => setOpenModal(false)}>
                <Iconify icon='mdi:close' />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        {currentModalAction && (
          <>
            <DialogContent sx={{ mb: 2}} >
              <Grid container>
                <Grid item xs={6}>
                  <Tree
                    nodeList={currentModalAction.nodeListSource}
                    multiSelect={currentModalAction.multiSelectSource}
                    selectionClick={selectionClick}
                    selectedFolder={selectedFolderFrom}
                    setSelectedFolder={setSelectedFolderFrom}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                </Grid>
                <Grid item xs={6} >
                  <Tree
                    sx={{backgroundColor:'action.hover'}}
                    nodeList={currentModalAction.nodeList}
                    multiSelect={currentModalAction.multiSelect}
                    selectionClick={selectionClick}
                    selectedFolder={selectedFolderTo}
                    setSelectedFolder={setSelectedFolderTo}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions display='flex' justifyContent='flex-end' marginRight='1rem'>
              {currentModalAction.buttons &&
                currentModalAction.buttons.map((button, index) => (
                  <Button
                    key={index}
                    variant='contained'
                    color='primary'
                    sx={button.style}
                    onClick={() => submitChanges(button)}
                  >
                    {button.label}
                  </Button>
                ))}
            </DialogActions>
          </>
        )}
      </Dialog>
    )}

    </>
  )
}

CustomBreadcrumbs.propTypes = {
  sx: PropTypes.object,
  actions: PropTypes.array,
  links: PropTypes.array,
  heading: PropTypes.string,
  moreLink: PropTypes.array,
  activeLast: PropTypes.bool,
}

// ----------------------------------------------------------------------

function Separator() {
  return (
    <Box
      component='span'
      sx={{
        width: 4,
        height: 4,
        borderRadius: '50%',
        bgcolor: 'text.disabled',
      }}
    />
  )
}
